import { formatSalesValue } from "../../utils/formatUtils"

const ElevenThree = ({ elevenThree }) => {
    return (
        <div className='time-stamp space-y-2 p-3'>
            <label className='morning'> 11AM -3PM <span>&#8594;   {elevenThree.pct + "%"}</span></label>
            <div>
                <span className='font-semibold'>Total Sales :</span> {elevenThree.total_count} X <span>{formatSalesValue(elevenThree.total_sales)}</span>
            </div>
            <div className='numbers space-y-2'>
                <div>
                    <span>Dine-In : </span> {elevenThree.dinein_sales === 'None' ? "-" : <>{elevenThree.dinein_count} X {formatSalesValue(elevenThree.dinein_sales)}</>}
                </div>
                <div>
                    <span>Take-away : </span>{elevenThree.tab_sales === 'None' ? "-" : <>{elevenThree.tab_count} X {formatSalesValue(elevenThree.tab_sales)}</>}
                </div>
            </div>
        </div>
    )
}

export default ElevenThree